import { Badge, Box, Button, Flex, Text } from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import { _localization } from "../../../config/location";
import React, { useEffect, useState } from "react";
import { green } from "../../../const/variables";
import { DatePickerInput } from "@mantine/dates";
import {
  keySearchCompareTBC,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { IconRefresh } from "@tabler/icons-react";
import { useIsFirstRender } from "@mantine/hooks";

const CompareTBC = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data1, setData1] = useState<any[]>([]);
  const [dataList1, setDataList1] = useState<any[]>([]);
  const [data2, setData2] = useState<any[]>([]);
  const [dataTemp, setDataTemp] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount1, setRowCount1] = useState(0);
  const [rowCount2, setRowCount2] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [loadingSync, setLoadingSync] = useState<boolean>(false);
  const [pagination1, setPagination1] = useState({
    pageIndex: 0,
    pageSize: 100,
  });

  const [pagination2, setPagination2] = useState({
    pageIndex: 0,
    pageSize: 100,
  });

  const firstRender = useIsFirstRender();
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";
  const _searchJson = (() => {
    try {
      const storedValue = sessionStorage.getItem(keySearchCompareTBC);
      return storedValue ? JSON.parse(storedValue) : null;
    } catch (error) {
      console.error("Lỗi khi parse JSON từ sessionStorage:", error);
      return null;
    }
  })();

  const [search, setSearch] = useState({
    Date:
      firstRender && _searchJson && checkedPinSearch
        ? _searchJson.Date
        : new Date(new Date().getTime() + 7 * 60 * 60 * 1000)?.toISOString(),
  });

  const columns1 = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "STT",
        header: "STT",
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilter: false,
        Cell: ({ row }) => <>{row?.index + 1}</>,
      },
      {
        accessorKey: "TBC",
        header: "Mã đơn thu báo có",
        Cell: ({ renderedCellValue, row }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            style={{ cursor: "pointer" }}
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue === null ? null : renderedCellValue}
          </Badge>
        ),
      },
    ],
    []
  );

  const columns2 = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "STT",
        header: "STT",
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilter: false,
        Cell: ({ row }) => <>{row?.index + 1}</>,
      },
      {
        accessorKey: "TBC",
        header: "Mã đơn thu báo có",
        Cell: ({ renderedCellValue, row }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            style={{ cursor: "pointer" }}
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue === null ? null : renderedCellValue}
          </Badge>
        ),
      },
    ],
    []
  );

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    const keySearchObj = {
      Date: search.Date,
    };

    try {
      let url = "/api/v1/CompareAsiaPos/so-sanh-thu-bc?type=1";

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        params.append(key, String(value));
      });
      url += `&${params.toString()}`;

      const res = await repositoryMdm.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData1(result.map((item: any) => ({ TBC: item })));
        setDataList1(result);
        setRowCount1(res.totalCount);
        table1.resetRowSelection();
      }
    } catch (error) {
      setData1([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      sessionStorage.setItem(keySearchCompareTBC, JSON.stringify(keySearchObj));
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const fetchDatav2 = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = "/api/v1/CompareAsiaPos/so-sanh-thu-bc?type=2";

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        params.append(key, String(value));
      });
      url += `&${params.toString()}`;

      const res = await repositoryMdm.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData2(result.map((item: any) => ({ TBC: item })));
        setRowCount2(res.totalCount);
        table2.resetRowSelection();
      }
    } catch (error) {
      setData2([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const syncToAsiaTBC = async () => {
    setIsLoading(true);
    const startData = pagination1.pageSize * pagination1.pageIndex;
    const endData = pagination1.pageSize * (pagination1.pageIndex + 1);
    try {
      const res = await repositoryPos.post<MessageResponse<any>>(
        "/sync-to-asia-tc?Type=1",
        dataList1.slice(startData, endData)
      );

      //   if (res && res.success) {
      //     setIsLoading(false);
      //     NotificationExtension.Success(
      //       "Đồng bộ dữ liệu POS lên ASIA thành công !"
      //     );
      //     setTimeout(() => {
      //       fetchData();
      //       fetchDatav2();
      //     }, 1000);
      //   }
      setTimeout(() => {
        setIsLoading(false);
        NotificationExtension.Info("Đã đồng bộ dữ liệu POS lên ASIA !");
      }, 3000);
      setTimeout(() => {
        fetchData();
        fetchDatav2();
      }, 1000);
    } catch (error) {
      setLoadingSync(false);
      console.error(error);
      return;
    } finally {
      setLoadingSync(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchDatav2();
  }, [search.Date]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (300 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table1 = useMantineReactTable({
    columns: columns1,
    data: data1,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => (
      <div
        ref={headerRef}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Badge color="blue">
          Danh sách phiếu thu/báo có có trên POS mà không có trên ASIA
        </Badge>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => <></>,

    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "code"],
        right: ["action"],
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount1,
    onPaginationChange: setPagination1,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "normal", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination1,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  const table2 = useMantineReactTable({
    columns: columns2,
    data: data2,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => (
      <div
        ref={headerRef}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Badge color="blue">
          Danh sách phiếu thu/báo có có trên ASIA mà không có trên POS
        </Badge>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => <></>,

    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "code"],
        right: ["action"],
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount2,
    onPaginationChange: setPagination2,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "normal", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination2,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  return (
    <Box w={"100%"}>
      <Flex
        w={"100%"}
        gap={"md"}
        wrap={"wrap"}
        justify={"space-between"}
        align={"center"}
        mt={5}
      >
        <Flex align={"center"} gap={"md"}>
          <Text fw="500">Ngày</Text>
          <DatePickerInput
            placeholder="Ngày"
            maxDate={new Date()}
            locale="vi"
            valueFormat="DD/MM/YYYY"
            clearable
            value={
              search.Date && search.Date.length > 0
                ? new Date(search.Date)
                : null
            }
            onChange={(e) =>
              setSearch((prev: any) => ({
                ...prev,
                Date: e
                  ? new Date(
                      new Date(e ?? "").getTime() + 7 * 60 * 60 * 1000
                    ).toISOString()
                  : "",
              }))
            }
            w={"200px"}
          />
        </Flex>
        <Button
          color="violet"
          leftSection={<IconRefresh size={14} />}
          onClick={() => syncToAsiaTBC()}
          loading={loadingSync}
        >
          Đồng bộ dữ liệu
        </Button>
      </Flex>
      {/* <Grid.Col span={{ base: 12, sm: 12, md: 6, lg: 3.5 }}>
          <Select
            placeholder="Loại đối chiếu"
            data={[
              {
                label: "Danh sách đơn hàng có trên pos mà không có trên asia",
                value: "1",
              },
              {
                label: "Danh sách đơn hàng có trên asia mà không có trên pos",
                value: "2",
              },
            ]}
            value={search.type}
            onChange={(e) =>
              setSearch((prev: any) => ({ ...prev, type: e ? e : "" }))
            }
          />
        </Grid.Col> */}
      <Flex mt={5} w={"100%"} gap={"md"}>
        <Box w={"50%"}>
          <MantineReactTable table={table1} />
        </Box>
        <Box w={"50%"}>
          <MantineReactTable table={table2} />
        </Box>
      </Flex>
    </Box>
  );
};

export default CompareTBC;
